export const hasMatchingArea = (
  itemArea: number | null | undefined,
  calculatedArea: number | null | undefined
): boolean => {
  if (itemArea == null || calculatedArea == null) return false;
  return itemArea === calculatedArea;
};
